import dayjs from "dayjs";
import { motion } from "framer-motion";
import { useState } from "react";
import { Empty, Tag, Tooltip } from "antd";

//APP
import { obterExecucoes } from "../talhoesFinalizados/meta";
import { Item__EquipeCliente } from "../../../../../../../services/Equipe/GET";
import { Item__Atividades } from "../../../../../../../services/atividades/GET";
import { leadZero, transition_default } from "../../../../../../../utils";

//COMPONENTS
import { Gap } from "../../../../../../../Components/CustomUi/gap";
import { RowItem } from "../../../../../../../Components/CustomUi/table/rowItem";
import { RowTable } from "../../../../../../../Components/CustomUi/table/rowTable";
import { Accordion } from "../../../../../../../Components/CustomUi/accordion";
import { BodyTable } from "../../../../../../../Components/CustomUi/table/bodyTable";
import { HeaderTable } from "../../../../../../../Components/CustomUi/table/headerTable";

//PROPS
interface TalhaoForaDoComum {
    nome_talhao: string;
    is_subarea?: boolean;
    nome_propriedade: string;
    cod_talhao: number;
    cod_propriedade: number;
    qtd_atividades: number;
    tipo_incomum: string;
    atvs_planejadas: Item__Atividades[];
    atvs_executadas: Item__Atividades[];
    atvs_concluidas: Item__Atividades[];
}

interface Props {
    lista_talhoes: TalhaoForaDoComum[];
    data_equipe_cliente: Item__EquipeCliente[];
    media_atvs: number;
}

export const ForaDoComum: React.FC<Props> = ({ lista_talhoes, data_equipe_cliente, media_atvs }) => {

    const [open_accordion, setOpen_accordion] = useState<number>(null);

    return (
        <section style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

            <p style={{ fontSize: 13, color: '#888', margin: 0, marginBottom: 4 }}>
                Média de atividades por talhão: <strong style={{ color: '#333' }}>{(media_atvs || 0).toFixed(1)}</strong>
            </p>


            {(lista_talhoes ?? []).map(({ nome_talhao, is_subarea, cod_talhao, nome_propriedade, qtd_atividades, tipo_incomum, atvs_planejadas, atvs_executadas }) => {
                return (
                    <Accordion
                        label={<div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'left'
                        }}>
                            <span style={{ fontWeight: 600, margin: 0 }}>{nome_talhao} <span style={{ color: 'var(--text-color-light)', fontSize: 12 }}>{is_subarea ? '(Subarea)' : ''}</span></span>
                            <span style={{ fontWeight: 600, fontSize: 11, color: 'var(--primary-color)', margin: 0 }}>{nome_propriedade}</span>
                        </div>}
                        open={cod_talhao === open_accordion}
                        trigger={open_accordion === cod_talhao ? () => { setOpen_accordion(null) } : () => { setOpen_accordion(cod_talhao) }}
                        single
                        extra={
                            <div style={{ display: 'flex', gap: 5 }}>
                                <Tag color={tipo_incomum === '50% ou menos que a média' ? 'geekblue' : 'error'} style={{ fontWeight: 500, alignSelf: 'center' }}>{tipo_incomum}</Tag>
                                <Tag color="orange" style={{ fontWeight: 500, alignSelf: 'center' }}>{qtd_atividades} atividade{qtd_atividades !== 1 ? 's' : ''}</Tag>
                            </div>
                        }
                    >
                        <motion.div
                            initial={{ opacity: 0, y: -5 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ ...transition_default }}
                        >

                            <Gap value={10} type="column" />

                            <HeaderTable
                                itens={[
                                    { valor: 'Operação', width: 121 },
                                    { valor: 'Atividade', width: 230.5 },
                                    { valor: 'Dias', width: 60 },
                                    { valor: 'Data', width: 165.5 },
                                    { valor: 'Conclusão', width: 100 },
                                    { valor: 'Patrimonios', width: 100 },
                                    { valor: 'Insumos', width: 100 },
                                ]}
                            />

                            <BodyTable>
                                {(obterExecucoes(atvs_planejadas, atvs_executadas, data_equipe_cliente).planejadas ?? []).map(({ operacao, descricao, dias, data, conclusao, patrimonios, insumos, referencia }) => {
                                    return (
                                        <RowTable>
                                            <RowItem width={120} style={{ textTransform: 'capitalize', fontSize: 13 }}>
                                                {String(operacao)?.toLowerCase()}
                                            </RowItem>
                                            <RowItem width={231} style={{ textTransform: 'capitalize', fontWeight: 500, lineHeight: 1.1, fontSize: 13 }}>
                                                {String(descricao)?.toLowerCase()}
                                            </RowItem>
                                            <RowItem width={60} style={{ padding: 0 }}>
                                                <div style={{
                                                    position: 'relative', width: 60, height: 54.2,
                                                    background: Number(dias) == 0 ? 'var(--atv-positivo)' : (Number(dias) < 0 ? 'var(--atv-negativo-light)' : 'var(--atv-positivo-light)'),
                                                    padding: 10, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    color: Number(dias) == 0 ? 'white' : (Number(dias) < 0 ? 'var(--atv-negativo)' : 'var(--atv-positivo)'), fontWeight: 600
                                                }}
                                                >
                                                    {Number(dias) > 0 ? '+' : ''}{dias}

                                                    <div style={{
                                                        width: 10,
                                                        height: 4,
                                                        background: (Number(dias) < 0 ? 'var(--atv-negativo)' : 'var(--atv-positivo)'),
                                                        position: 'absolute',
                                                        top: 5,
                                                        left: referencia === 1 ? 2 : (referencia === 2 ? 25 : 48),
                                                        borderRadius: '5px'
                                                    }}></div>
                                                </div>
                                            </RowItem>
                                            <RowItem width={165} style={{ fontSize: 13 }}>
                                                {data}
                                            </RowItem>
                                            <RowItem width={100}>
                                                {conclusao}
                                            </RowItem>
                                            <RowItem width={100}>
                                                <Tooltip title={patrimonios.map((i) => { return (<>- {String(i.patrimonio_nome)}<br /></>) })}>
                                                    <div style={{
                                                        width: 30, height: 30, borderRadius: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        background: Number(dias) == 0 ? 'var(--atv-positivo)' : (Number(dias) < 0 ? 'var(--atv-negativo-light)' : 'var(--atv-positivo-light)'),
                                                        color: Number(dias) == 0 ? 'white' : (Number(dias) < 0 ? 'var(--atv-negativo)' : 'var(--atv-positivo)'), fontWeight: 600,
                                                        opacity: (patrimonios ?? [])?.length === 0 ? 0.3 : 1
                                                    }}
                                                    >
                                                        {leadZero((patrimonios ?? [])?.length)}
                                                    </div>
                                                </Tooltip>
                                            </RowItem>
                                            <RowItem width={105}>
                                                <Tooltip title={insumos.map((i) => { return (<>- {String(i.insumo_nome)}<br /></>) })}>
                                                    <div style={{
                                                        width: 30, height: 30, borderRadius: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        background: Number(dias) == 0 ? 'var(--atv-positivo)' : (Number(dias) < 0 ? 'var(--atv-negativo-light)' : 'var(--atv-positivo-light)'),
                                                        color: Number(dias) == 0 ? 'white' : (Number(dias) < 0 ? 'var(--atv-negativo)' : 'var(--atv-positivo)'), fontWeight: 600,
                                                        opacity: (insumos ?? [])?.length === 0 ? 0.3 : 1
                                                    }}
                                                    >
                                                        {leadZero((insumos ?? [])?.length)}
                                                    </div>
                                                </Tooltip>
                                            </RowItem>

                                        </RowTable>
                                    )
                                })}
                            </BodyTable>

                            {(obterExecucoes(atvs_planejadas, atvs_executadas, data_equipe_cliente).planejadas ?? []).length === 0 && (
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={"Nenhuma atividade planejada!"} />
                            )}

                        </motion.div>
                    </Accordion>
                )
            })}

            {(lista_talhoes ?? []).length === 0 && (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={"Nenhum talhão fora do comum!"} />
            )}

        </section>
    )
};
